import { render, staticRenderFns } from "./ChatSocketComponent.vue?vue&type=template&id=41546b24"
import script from "./ChatSocketComponent.vue?vue&type=script&lang=js"
export * from "./ChatSocketComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatSocketComponent.vue?vue&type=style&index=0&id=41546b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports